import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "@environment";
// import { ConfigService } from "../config.service";
import {BehaviorSubject, Subject} from "rxjs";
import { IGaeEditorList } from "src/app/_interfaces/IGaeEditorList";
import { ISystemPreferences } from "src/app/_interfaces/ISystemPreferences";
import { EditorGeographicArea } from "src/app/_models/user/editorGeographicArea";
import { JurisdictionalAgency, User } from "../../_models";
import { IUserProfile } from "src/app/_interfaces/IUserProfile";
import { GeographicArea } from "src/app/_models/user/geographicArea";

@Injectable({
  providedIn: "root",
})
export class UserDetailsService {
  // private readonly baseUrl = environment.userApi.baseUrl;
  // private readonly setUserProfileUrl = environment.userApi.setUserProfile;
  // private readonly setUserGeographicAreaUrl = environment.userApi.setUserGeographicArea;
  // private readonly setUserAgencyUrl = environment.userApi.setUserAgency;
  private readonly setUserProfileUrl = (userId) => `/${userId}/userProfile`;
  private readonly setUserGeographicAreaUrl = (userId) => `/${userId}/geographicArea`;
  private readonly setUserAgencyUrl = (userId) => `/${userId}/jurisdictionalAgency`;

  public userEvent = new Subject<string>();

  constructor(private http: HttpClient) {}

  getUserById(userId: number, baseUrl: string) {
    return this.http.get<User>(`${baseUrl}/${userId}`);
  }

  getUserByUserName(userName: string, baseUrl: string){
    return this.http.get<User>(`${baseUrl}/username/?username=${userName}`);
  }

  getUserSecurityInfo(userId: number, baseUrl: string) {
    return this.http.get<User>(`${baseUrl}/${userId}/userSecurityInfo`);
  }

  saveUserEditorGaeList(userId: number, gaeEditorList: IGaeEditorList, baseUrl: string) {
    return this.http.put<EditorGeographicArea[]>(
      `${baseUrl}/${userId}/editorGeographicAreas`,
      gaeEditorList
    );
  }

  saveUserProfile(userId: number, userProfile: IUserProfile, baseUrl: string) {
    return this.http.put<IUserProfile>(
      `${baseUrl}${this.setUserProfileUrl(userId)}`,
      userProfile
    );
  }

  /**
   * @param userId User Id of the user
   * @param selectedGeographicAreaGacc Set to empty string '' to remove the Gacc for this user
   * @returns User object
   */
  setUserGeographicArea(userId: number, selectedGeographicAreaGacc: string, baseUrl: string) {
    return this.http.get<User>(
      `${baseUrl}${this.setUserGeographicAreaUrl(userId)}`, {
        params: {
          gacc: selectedGeographicAreaGacc
        }
      }
    );
  }

  /**
   * @param userId User Id of the user
   * @param selectedAgencyId Set to -1 to remove the agency for this user
   * @returns User object
   * */
  setUserAgency(userId: number, selectedAgencyId: number, baseUrl: string) {
    return this.http.get<User>(
      `${baseUrl}${this.setUserAgencyUrl(userId)}`, {
        params: {
          agencyId: selectedAgencyId
        }
      }
    );
  }
}
